import {DictionaryCode} from '../enums/dictionary-code.enum';

export class DictionaryItem {
    id: number;
    code: string;
    deleted = false;
    description: string;
    descriptionTranslationCode: string;
    flexField1: string;
    flexFilter1: string[];
    orderIndex: number;

    constructor(props = {}) {
        Object.assign(this, props);
    }
}

export class Dictionary {
    code: DictionaryCode;
    description: string;
    editable = false;
    flexField1: string;
    id: number;
    itemList: DictionaryItem[] = [];

    constructor(props = {}) {
        Object.assign(this, props);
    }
}

export class DictionaryItemSimplified {
    code: string;
    description: string;
}
